import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Toggle } from '@zola/zola-ui';
import './PublishBanner.styles.less';


const PublishBanner = ({ title, published, handleOnPublishWebsite }) => {
  const classes = cx(
    'mpr-publish-banner',
    { 'mpr-publish-banner--published': published },
    { 'mpr-publish-banner--unpublished': !published }
  );

  return (
    <div className={classes}>
      <div className="mpr-publish-banner__actions">
        <p className="mpr-publish-banner__title">{title}</p>
        <div className="mpr-publish-banner__toggle">
          <Toggle input={{ value: published, onChange: handleOnPublishWebsite }} />
        </div>
      </div>
    </div>
  );
};


PublishBanner.propTypes = {
  title: PropTypes.string.isRequired,
  published: PropTypes.bool.isRequired,
  handleOnPublishWebsite: PropTypes.func.isRequired,
};


export default PublishBanner;



// WEBPACK FOOTER //
// ./src/components/manage/website/ManagePagesRedesign/WebAdmin/PublishBanner/PublishBanner.jsx